import { useEffect, useState } from 'react';
import { CONTAINERS } from 'pages/shared';
import { useAzureStorage, useFormState, domHelper, fileHelper } from 'shared';

export function useAnalyticsReportForm(report, onChangeInput) {
  const [reportInputs, setReportInputs] = useFormState(report, onChangeInput);
  const { getReadSasToken } = useAzureStorage(CONTAINERS.ANALYTICS_REPORTS);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    setReportInputs({ ...report }, false);
  }, [report]);

  const handleChange =
    fieldName =>
    ({ target }) => {
      setReportInputs(inputs => ({ ...inputs, [fieldName]: target.value }));
    };

  async function handleSelectFile(acceptedFile) {
    const file = acceptedFile[0];
    if (file) {
      const readedFile = await fileHelper.asyncFileReader(file);

      setReportInputs(prevInputs => ({
        ...prevInputs,
        reportFileUrl: '',
        reportFileName: file.path,
        reportFileMimeType: file.mimeType,
        selectedFile: readedFile
      }));

      setSubmitted(false);
    }
  }

  function handleDeleteFile() {
    setReportInputs(prevInputs => ({
      ...prevInputs,
      selectedFile: null,
      reportFileName: '',
      reportFileMimeType: '',
      reportFileUrl: ''
    }));

    setSubmitted(false);
  }

  async function handleDownload([documentUrl]) {
    if (documentUrl) {
      const token = await getReadSasToken();
      const downloadUrl = documentUrl + '?' + token;
      domHelper.downloadFile(downloadUrl, documentUrl.replace(' ', '_'));
    }
  }

  return {
    reportInputs,
    handleChange,
    handleSelectFile,
    handleDeleteFile,
    handleDownload,
    submitted,
    setSubmitted
  };
}
